export const createAction = (type) => {
    const actionCreator = (payload) => ({
        type,
        payload,
    });

    actionCreator.type = type;
    actionCreator.toString = () => type;

    return actionCreator;
}

export const createReducer = (initialState, reducers) => {
    const reducer = (state = initialState, action) => {
        const caseReducer = reducers[action.type];

        if (!caseReducer) return state;

        return caseReducer(state, action.payload);
    };

    return reducer;
}

const actionTypeBuilder = name => action => name ? `${name}/${action}` : action;

export default function createSlice({ name, initialState, reducers, extraReducers = {} }) {
    const actionKeys = Object.keys(reducers);
    const createActionType = actionTypeBuilder(name);

    const reducerMap = actionKeys.reduce((map, action) => {
        map[createActionType(action)] = reducers[action];
        return map;
    }, extraReducers);

    const reducer = createReducer(initialState, reducerMap);

    const actionMap = actionKeys.reduce((map, action) => {
        const type = createActionType(action);

        map[action] = createAction(type);
        return map;
    }, {});

    return {
        actions: actionMap,
        reducer,
        name
    };
}